module.exports = "┏━━━━━┓\n┣━━━━━┫\n┃╱╱╱╱╱┃\n┃╱╱╱╱╱┃\n┃╱╱╱╱╱┃\n┗━━━━━┛";


//////////////////
// WEBPACK FOOTER
// ./src/templates/401/401.preview.html
// module id = 284
// module chunks = 0